import React from 'react'
// import StarRating from './rating'
// const Footer = () => {
//   return (
//     <div>
//       <div className='mainContainer3'>
//           <div className='footer'>
//               <div className='social'>
//                   <i class="fa-brands fa-facebook" style={{color: '#e4e9f1',fontSize: "30px"}}></i>
//                   <i class="fa-brands fa-instagram" style={{color: "#ffffff",fontSize: "30px"}}></i>
//                   <i class="fab fa-twitter-square" style={{color: "#fafffd",fontSize: "30px"}}></i>
//                   <i class="fa-brands fa-linkedin" style={{color: "#fafffd",fontSize: "30px"}}></i>
//               </div>
//           </div>
//       </div>
//     </div>
//   )
// }

// export default Footer


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* <p>&copy; {new Date().getFullYear()} goldentreefpc.com. All rights reserved,Developed by SDA Infosys</p> */}
        <p>
          &copy; {new Date().getFullYear()} goldentreefpc.com. All rights reserved. Developed by  <span style={{color:'whitesmoke',fontSize:'20px',cursor:'pointer'}}><a href="https://sdainfosys.com/" target="_blank" rel="noopener noreferrer" 
          style={{ color: '#fff', textDecoration: 'none' }}>
            SDA Infosys
          </a></span>.
        </p>
        <div className="social-icons">
        <i class="fa-brands fa-facebook" style={{color: '#e4e9f1',fontSize: "20px",padding:'10px'}}></i>
        <i class="fa-brands fa-instagram" style={{color: "#ffffff",fontSize: "20px",padding:'10px'}}></i>
        <i class="fab fa-twitter-square" style={{color: "#fafffd",fontSize: "20px",padding:'10px'}}></i>
        <i class="fa-brands fa-linkedin" style={{color: "#fafffd",fontSize: "20px",padding:'10px'}}></i>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
